import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {
  Card,
  Icon,
  Table,
  Loader,
  Popup,
  Checkbox,
  Dropdown,
} from 'semantic-ui-react';
import {printDateFormat} from '../../../../common/constants/datesFormat';
import {pageSizes} from '../../../../common/constants/lists';
import {Actions} from '../../../../common/actions';
import TablePaginator from '../../../../common/components/tablePaginator';

const statusDictionary = {
  'P': 'Pendiente',
  'E': 'En Proceso',
};

class ManualsOrderDetailTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'checkedAllItems': false,
    };
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
    this.onPageClick = this.onPageClick.bind(this);
  }

  onPageSizeClick(event, data) {
    this.props.changeOrdersListPageSize(data.value);
  }

  onPageClick(value) {
    this.props.changeOrdersListPage(value);
  }

  onSelectedItemsCheckboxChange(position, event, value) {
    if (position === 'ALL') {
      this.setState({'checkedAllItems': !this.state.checkedAllItems});
    }
    this.props.changeStatusForSelectedItem(position, value.checked);
  }

  printPickinglabels(orderSequence) {
    const {orderNumber} = this.props;
    this.props.printPickingLabelsByOrderNumberAndSequential(
      orderNumber,
      orderSequence
    );
  }

  renderPagination() {
    const {pageNumber, pageSize, totalItems} = this.props;

    if (totalItems <= pageSize) {
      return null;
    }
    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick}
                />
              </span>
              <TablePaginator
                itemsCount={totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  renderCheckbox(element, position) {
    const {saving} = this.props;
    if (element.status !== 'P') {
      return null;
    }
    return (
      <Checkbox
        checked={element.checked}
        onChange={this.onSelectedItemsCheckboxChange.bind(this, position)}
        disabled={saving}
      />
    );
  }

  renderPrintIcon(element) {
    if (element.status !== 'E') {
      return null;
    }
    return (
      <Popup
        trigger={
          <Icon
            name='print'
            color='blue'
            size='large'
            onClick={this.printPickinglabels.bind(this, element.orderSequence)}
          />
        }
        content='Imprimir'
        position='top center'
        inverted
      />
    );
  }

  renderItems() {
    const {items, pageNumber, pageSize} = this.props;
    if (!items.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={6}>
            No hay item para este pedido
          </Table.Cell>
        </Table.Row>
      );
    }

    return items.map((element, index) => {
      const dateFormatted = element.printDate ?
        moment(element.printDate).format(printDateFormat) :
        '';
      const position = pageNumber * pageSize + index;
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>
            {this.renderCheckbox(element, position)}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.partCode}</Table.Cell>
          <Table.Cell textAlign='center'>{element.description}</Table.Cell>
          <Table.Cell textAlign='center'>{element.quantity}</Table.Cell>
          <Table.Cell textAlign='center'>
            {statusDictionary[element.status]}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {dateFormatted.toUpperCase()}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {this.renderPrintIcon(element)}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderData() {
    const {loading} = this.props;
    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderItems();
  }

  render() {
    const {loading, saving} = this.props;

    return (
      <Card fluid raised className='primary-content'>
        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>
                <Checkbox
                  label='Seleccionar'
                  checked={this.state.checkedAllItems}
                  onChange={this.onSelectedItemsCheckboxChange.bind(
                    this,
                    'ALL'
                  )}
                  disabled={loading || saving}
                />
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Cod. Parte</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>
                Descripción
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Cantidad</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Estado</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>
                Fecha de impresion
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Acciones</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{this.renderData()}</Table.Body>

          {this.renderPagination()}
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.manualsOrders.loadingOrderDetail,
    'items': state.manualsOrders.orderDetailItemsByPage,
    'totalItems': state.manualsOrders.orderDetailItems.length,
    'pageNumber': state.manualsOrders.pageNumber,
    'pageSize': state.manualsOrders.pageSize,
    'saving': state.manualsOrders.saving,
  };
};

const {
  changeOrdersListPage,
  changeOrdersListPageSize,
  changeStatusForSelectedItem,
  printPickingLabelsByOrderNumberAndSequential,
} = Actions;

export default connect(mapStateToProps, {
  changeOrdersListPage,
  changeOrdersListPageSize,
  changeStatusForSelectedItem,
  printPickingLabelsByOrderNumberAndSequential,
})(ManualsOrderDetailTable);
